import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import Styles from '../AIRequestDrawer.module.scss'
import { ReviseButton } from 'components/BlazeCommandLine/components/ReviseButton'
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from 'components/Wizards/Wizard/Form/LanguageInputField/LanguageInput'
import { useLastUsedLanguage } from 'hooks/queries/useLastUsedLanguage'
import { Text } from 'blaze-ui/Text/Text'
import { RevisionType } from 'components/BlazeCommandLine/Types'
import { ListSelect } from 'components/ListSelect/ListSelect'
import { Selection } from '@react-types/shared'
import { Item } from '@react-stately/collections'
import { AISuggestionProps } from '../Types'

export const Translate = observer(({ articleId, layerId, editorState, onRevise, promptProps }: AISuggestionProps) => {
  const defaultLanguageQuery = useLastUsedLanguage()
  const defaultLanguage = defaultLanguageQuery?.data?.language
  const [selectedLanguage, setSelectedLanguage] = useState<string>(DEFAULT_LANGUAGE)

  const englishOptions = ['English', 'English (UK)', 'English (Australia)']

  useEffect(() => {
    if (!!defaultLanguage) setSelectedLanguage(defaultLanguage)
  }, [defaultLanguage]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (selection: Selection) => {
    if (!(selection instanceof Set)) return

    const [action] = selection
    setSelectedLanguage(action as string)
  }

  return (
    <div className={Styles.suggestedAction}>
      <Text variant="placeholder" color="var(--dark-80)">
        Select Language to translate to
      </Text>

      <ListSelect selectedKeys={[selectedLanguage]} onSelectionChange={handleChange}>
        {englishOptions.map((language) => (
          <Item key={language}>{language}</Item>
        ))}
      </ListSelect>
      <ListSelect selectedKeys={[selectedLanguage]} onSelectionChange={handleChange}>
        {SUPPORTED_LANGUAGES.filter((l) => !englishOptions.includes(l)).map((language) => (
          <Item key={language}>{language}</Item>
        ))}
      </ListSelect>

      <ReviseButton
        almanacEditorState={editorState}
        articleId={articleId}
        layerId={layerId}
        prompt={{ revision_type: RevisionType.TRANSLATE, language: selectedLanguage || 'English' }}
        onRevise={onRevise}
        label="Translate"
        {...promptProps}
      />
    </div>
  )
})
